export default "__VITE_ASSET__BSjHvABc__"